import { logoHeight, logoWidth, pageTitleFontSize, white_smoke } from "../../StyleHelpers";
import { TouchableWithoutFeedback, View } from "react-native";
import TouchableOpacity from "../TouchableOpacity/TouchableOpacity";
import Image from "../Image/Image";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import searchIcon from "../../assets/TopNavBarIcon/icon_nav_search.png";
import Text from "../Text/Text";
import ridevueLogo from "../../assets/Logo/iconLogo.svg";
import ImgProgressBar from "../Loaders/ImgProgressBar";
import { TextInput } from "react-native-paper";
import closeIcon from "../../assets/Icons/x.svg";
import { useEffect, useRef, useState } from "react";
import useGenericContentStore from "../../store/genericContent.store";
import { DEFAULT_ENV } from "../../config/ENV_CONFIG";
import ENVIRONMENT from "../../config/ENVIRONMENT";
import {
	StyledCloseContainer,
	StyledContainer,
	StyledIconContainer,
	StyledIconRenderer,
	StyledLoading,
	StyledText,
	StyledTextContainer,
	styles,
} from "./styled";
import { Props } from "./model";
import { isRHD } from "../../utils/Utils";

let pressCount = 0;

const TopAppBar = (props: Props) => {
	const textRef: any = useRef();
	const [clickCount, setClickCount] = useState(1);
	const setIsHide = useGenericContentStore((state: any) => state.setIsHide);
	const setIsDebugVisible = useGenericContentStore((state: any) => state.setIsDebugVisible);
	const rightImageLandscapeStyle = props.isNarrow ? { width: 98, height: 55, marginRight: 32 } : { width: 156, height: 88, marginRight: 32 };
	const rightImagePortraitstyle = props.isNarrow ? { width: 37, height: 55, marginRight: 32 } : { width: 64, height: 96, marginRight: 32 };

	const iconRender = () => (
		<StyledIconRenderer
			isNarrow={props.isNarrow}
			leftIconWidth={props.leftIconWidth}
			source={{ uri: props.leftIcon ? props.leftIcon : backIcon }}
		/>
	);

	const titleRender = () =>
		!props?.isHideLeftIcon ? (
			<View style={props.isNarrow ? styles.narrowImage : styles.centerImage}>
				<TouchableOpacity onPress={props.onPressLeftTitleIcon}>
					{/* @ts-ignores */}
					<StyledIconContainer isNarrow={props.isNarrow} leftIconWidth={props.leftIconWidth}>
						<StyledIconRenderer
							isNarrow={props.isNarrow}
							leftIconWidth={props.leftIconWidth}
							source={{ uri: props.leftTitleIcon ? props.leftTitleIcon : backIcon }}
						/>
					</StyledIconContainer>
				</TouchableOpacity>
			</View>
		) : (
			<StyledCloseContainer />
		);

	const showAdvanceSettings = () => {
		const newCount = clickCount + 1;
		setClickCount(newCount);
		if (clickCount === 10) {
			setIsHide(false);
			return setClickCount(1);
		}
	};

	const renderTitleLogo = () => {
		return props.titleLogo ? (
			<View style={props.isPreview ? styles.stylesPreview : {}}>
				<TouchableWithoutFeedback onPressIn={handleLogoPressIn}>
					<Image
						source={{ uri: props.titleLogo ? props.titleLogo : ridevueLogo }}
						resizeMode={"contain"}
						width={logoWidth}
						height={logoHeight}
					/>
				</TouchableWithoutFeedback>
			</View>
		) : (
			<></>
		);
	};

	const renderLoading = () => {
		if (!props.screenTitle && !props.titleLogo && !props.search) {
			return (
				// @ts-ignore
				<StyledLoading>
					<ImgProgressBar />
				</StyledLoading>
			);
		}
		return null;
	};

	const renderScreenTitle = () => {
		if (!props.screenTitle) return null;

		let fontSize: number;

		if (props.screenTitleBody) {
			fontSize = props.isNarrow ? 26 : 33;
		} else {
			fontSize = props.isNarrow ? 40 : 50;
		}

		const textProps = {
			fontSize: pageTitleFontSize,
			style: [styles.screenLabel, { fontSize }],
			numberOfLines: 1,
			ellipsizeMode: "tail" as const,
		};

		return (
			<View>
				{/* @ts-ignore */}
				<StyledText isNarrow={props.isNarrow} isNav={props.isNav}>
					{props.isSettings && DEFAULT_ENV !== ENVIRONMENT.PRODUCTION ? (
						<Text {...textProps} onPress={showAdvanceSettings}>
							{props.screenTitle}
						</Text>
					) : (
						<Text {...textProps}>{props.screenTitle}</Text>
					)}
					<Text
						fontSize={pageTitleFontSize}
						style={props.isNarrow ? styles.titleBodyNarrow : styles.titleBody}
						numberOfLines={1}
						ellipsizeMode=""
					>
						{props.screenTitleBody}
					</Text>
				</StyledText>
			</View>
		);
	};

	const renderSearchInput = () => {
		if (!props.search) return null;

		return (
			// @ts-ignore
			<TextInput
				mode="outlined"
				style={props.isNarrow ? styles.narrowSearchTextInput : styles.searchTextInput}
				placeholder={props.placeholder}
				onChangeText={props.onChangeText}
				outlineColor="gray"
				activeOutlineColor={white_smoke}
				textColor={white_smoke}
				outlineStyle={styles.outlineStyle}
				placeholderTextColor="gray"
				value={props.inputValue}
				focusable={props.autoFocus}
				ref={textRef}
				right={
					props.inputValue ? (
						// @ts-ignore
						<TextInput.Icon
							icon={closeIcon}
							onPress={props.onPressInputIcon}
							style={{ marginTop: props.isNarrow ? 8 : 15, marginRight: 50 }}
							iconColor={white_smoke}
							size={30}
						/>
					) : null
				}
			/>
		);
	};

	const renderTitle = () => {
		return (
			//@ts-ignore
			<StyledTextContainer addTitleMarginLeft={props.addTitleMarginLeft}>
				{renderLoading()}
				{renderScreenTitle()}
				{renderTitleLogo()}
				{renderSearchInput()}
			</StyledTextContainer>
		);
	};

	const renderWheelPositionRightLogo = () => {
		return (
			<>
				{props.rightImage && !isRHD() ? (
					<Image
						source={props.rightImageLandscape ? { uri: props.rightImageLandscape } : { uri: props.rightImagePortrait }}
						style={[styles.rightImage, props.rightImageLandscape ? rightImageLandscapeStyle : rightImagePortraitstyle]}
					/>
				) : (
					<></>
				)}
			</>
		);
	};

	const renderRightLogo = () => {
		return (
			<View style={styles.rightImageContainer}>
				{/* @ts-ignores */}
				{props.rightIcon ? (
					<TouchableOpacity onPress={props.onPressRightIcon}>
						<Image
							source={{ uri: props.rightIcon ? props.rightIcon : searchIcon }}
							width={props.isNarrow ? 80 : 122}
							height={props.isNarrow ? 80 : 122}
							style={styles.backIcon}
						/>
					</TouchableOpacity>
				) : (
					<></>
				)}
				{props.rightLogo ? (
					//@ts-ignores
					<TouchableWithoutFeedback onPressIn={handleLogoPressIn}>
						<Image
							source={{ uri: props.rightLogo ? props.rightLogo : ridevueLogo }}
							resizeMode={"contain"}
							width={props.isSingleLogo ? 46 : logoWidth}
							height={props.isSingleLogo ? 46 : logoHeight}
						/>
					</TouchableWithoutFeedback>
				) : (
					<></>
				)}
				{renderWheelPositionRightLogo()}
			</View>
		);
	};

	const renderRightPackshot = () => {
		if (!props.rightImage) return;

		return (
			<View style={styles.centerImage}>
				{/* @ts-ignores */}
				{props.rightImage ? (
					<Image
						source={props.rightImageLandscape ? { uri: props.rightImageLandscape } : { uri: props.rightImagePortrait }}
						style={[styles.rightImage, props.rightImageLandscape ? rightImageLandscapeStyle : rightImagePortraitstyle]}
					/>
				) : (
					<></>
				)}
			</View>
		);
	};

	/**
	 * Set setTimeout to 5 seconds after timeout it will
	 * set the `setDialogVisible` to true
	 */
	const handleLogoPressIn = () => {
		pressCount = pressCount + 1;
		if (pressCount === 10) {
			setIsDebugVisible(true);
			pressCount = 0;
		}
	};

	const renderCloseContainer = () => {
		return !props.screenTitle && !props.titleLogo && !props.search ? <StyledCloseContainer /> : <></>;
	};

	const renderTopAppBarRight = () => {
		return (
			<View style={styles.innerContainer}>
				{renderRightLogo()}
				{renderTitle()}
				{renderRightPackshot()}
				{props.search || (!props.isNav && props.screenTitle) ? titleRender() : <></>}
				{props.isShowClose ? (
					<View style={styles.centerImage}>
						{/* @ts-ignore */}
						<TouchableWithoutFeedback onPress={props.onPressLeftIcon} onPressIn={handleLogoPressIn}>
							{/* @ts-ignores */}
							<StyledIconContainer leftIconWidth={!props.screenTitle && !props.search && props.leftIconWidth}>
								{/* @ts-ignores */}
								{props.screenTitle || props.titleLogo || props.search ? iconRender() : <></>}
							</StyledIconContainer>
						</TouchableWithoutFeedback>
					</View>
				) : (
					<></>
				)}
			</View>
		);
	};

	const renderTopAppBarLeft = () => {
		return (
			<View style={styles.innerContainer}>
				{props.isShowClose ? (
					<View style={styles.centerImage}>
						{/* @ts-ignore */}

						<TouchableWithoutFeedback onPress={props.onPressLeftIcon} onPressIn={handleLogoPressIn}>
							{/* @ts-ignores */}
							<StyledIconContainer leftIconWidth={!props.screenTitle && !props.search && props.leftIconWidth}>
								{/* @ts-ignores */}
								{props.screenTitle || props.titleLogo || props.search ? iconRender() : <></>}
							</StyledIconContainer>
						</TouchableWithoutFeedback>
					</View>
				) : (
					renderCloseContainer()
				)}
				{props.search || (!props.isNav && props.screenTitle) ? titleRender() : <></>}
				{renderTitle()}
				{renderRightLogo()}
			</View>
		);
	};

	useEffect(() => {
		let mounted = true;

		if (mounted && props.autoFocus === true) {
			textRef.current.focus();
		}

		return () => {
			mounted = false;
		};
	}, [props.autoFocus]);

	return (
		// @ts-ignores
		<StyledContainer
			isNarrow={props.isNarrow}
			isNav={props.isNav}
			screenTitle={props.screenTitle}
			titleLogo={props.titleLogo}
			search={props.search}
			isRHD={isRHD()}
		>
			{isRHD() ? renderTopAppBarRight() : renderTopAppBarLeft()}
		</StyledContainer>
	);
};

export default TopAppBar;
